import {useNotificaciones} from "./hooks/useNotificaciones";
import {ITableColumn, TableList} from "../../components/table";
import {QueryStatus} from "../../types";
import {NotificacionVistaDTO, NotificacionVistaFields} from "./api/schemas";
import React from "react";
import {addDays, format, isToday, isYesterday} from 'date-fns';
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import {useTranslation} from "react-i18next";

import {es} from 'date-fns/locale';
import {useNavigate} from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {IconButton, Tooltip} from "@mui/material";
import {rutaPorCodSistema} from "../sistema/RefactorLayout";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {NotificationItem} from "../../@core/layouts/components/shared-components/components/NotificationMenu";


const Notifications = () => {
    const {t} = useTranslation()

    const {notificaciones, status} = useNotificaciones()
    const navigate = useNavigate()

    const columnas: ITableColumn[] = [
        {
            label: "", value: NotificacionVistaFields.Prioridad, width: '1%',

            onRenderCell: (notificacion: NotificacionVistaDTO) =>
                notificacion[NotificacionVistaFields.Prioridad] ?
                    <WarningAmberIcon sx={{
                        fill: (theme) => theme.palette.error.main,
                        fontSize: "19px !important",
                        mt: '40%'
                    }}/> : <></>
        },
        {label: "Id Mensaje", value: NotificacionVistaFields.IdMensaje, width: '5%'},
        {
            label: "Notificacion", value: NotificacionVistaFields.Mensaje, width: '65%',
            onRenderCell: (notificacion: NotificacionVistaDTO) =>

                // <Stack direction={'row'}>
                //     <RenderAvatar notification={notificacion}/>
                //     <Stack direction={'column'}>
                //         <Typography>
                //             {notificacion[NotificacionVistaFields.Titulo]}
                //         </Typography>
                //         <Typography variant='caption' sx={{color: 'text.disabled'}}>
                //             {notificacion[NotificacionVistaFields.Mensaje]}
                //         </Typography>
                //     </Stack>
                // </Stack>
                <NotificationItem notification={notificacion} alertIcon={false}/>

        },
        {
            label: "Fecha", value: NotificacionVistaFields.Fecha,
            width: '15%',
            onRenderCell: (notificacion: NotificacionVistaDTO) => {
                const notificationDate = notificacion[NotificacionVistaFields.Fecha]
                let formattedDate;

                if (isYesterday(notificationDate)) {
                    formattedDate = 'Ayer';
                } else if (isToday(notificationDate)) {
                    formattedDate = 'Hoy';
                } else {
                    formattedDate = format(addDays(notificationDate, 1), `do  MMMM`, {locale: es});
                }

                return <span>{formattedDate}</span>
            }
        },
        {
            label: "Acciones",
            width: '5%',
            onRenderCell: (notificacion: NotificacionVistaDTO) => {
                const {idMensaje, codSistema} = notificacion

                return (
                    <Tooltip title='Ver Mensaje'>
                        <IconButton
                            onClick={() => navigate(`/operacion/${rutaPorCodSistema[codSistema]}/${idMensaje}`)}>
                            <VisibilityIcon color='primary'/>
                        </IconButton>
                    </Tooltip>
                )
            }

        }
    ]

    return (
        <Card>
            <CardHeader title={t('Notificaciones')}/>
            <TableList<NotificacionVistaDTO>
                entityList={notificaciones} columns={columnas}
                isLoading={status === QueryStatus.Loading} error={false}
            />
        </Card>
    )
}

export default Notifications
